import React from "react";
import SideBar from "../../components/sidebar/Sidebar";
//import { useState } from 'react'
import { Notification } from "../../components/alerting-visitors/notification";
import TrusteeBase from "../../components/trustee/TrusteeBase";
import "../../css/myestare.css";

function TrusteeJewelry() {


  return (
    <TrusteeBase>
      <div className="mt-5"></div>
      <SideBar>
        <div>
        <div style={{ marginTop: "30px" }}>
          <Notification />
        </div>

        </div>
      </SideBar>
      {/* <div>
        <Footer />
      </div> */}
    </TrusteeBase>
  );
}

export default TrusteeJewelry;
